export const PAGE_SIZE = 20;
export const CACHE_KEY = 'alert-rules';
